<template>
  <div class="row bloc-information">
    <div class="col-lg-6">
      <div class="ibox float-e-margins">
        <div class="ibox-content col-lg-4" style="min-height: 155px;">
          <a :href="vehicleUrl" target="_blank">
            <img :src="vehicle.photo" class="img-vehicle">
          </a>
        </div>
        <div class="col-lg-8 no-paddings">
          <div class="ibox-title">
            <h5 style="position:absolute; width:96%;">
              <a v-if="canEditVehicle" @click.prevent.stop="addVehicle"><span class="pull-right" style="padding-right:20px;"><i class="fa fa-pencil"></i></span></a>
              <strong>{{ `${vehicle.make} ${vehicle.model} ${vehicle.version}` }}</strong><br>
              <span class="orange">{{ price.toLocaleString() }} €</span>
            </h5>
          </div>
          <div class="ibox-content" style="border-top:none;">
            <i class="fa fa-road"></i> {{ vehicle.kilometers.toLocaleString() }} km<br>
            <i class="fa fa-money"></i> {{ vehicle.fuel }}<br>
            <i class="fa fa-flag-checkered"></i>
            <span v-if="vehicle.licensePlate"> {{ vehicle.licensePlate }},</span>
            {{ vehicle.year }},
            {{ vehicle.gearType }}, {{ vehicle.city }} ({{ vehicle.department }})<br>
            <a v-if="command.appraisal" :href="appraisalEditUrl"
               v-tooltip="{
                content: appraisalLabel,
                placement: 'bottom-center'
               }"
               target="_blank"
            >
              <i class="fa fa-user"></i> {{ appraisalLabel }}
            </a>
          </div>

        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <a v-if="canEditBuyer" :href="getCustomerEditUrl(seller.id)" target="_blank">
            <span class="pull-right"><i class="fa fa-pencil"></i></span>
          </a>
          <h5>Vendeur</h5>
        </div>
        <div class="ibox-content">
          <i class="fa fa-user"></i> {{ seller.firstname + ' ' + seller.lastname }}<br>
          <i class="fa fa-phone"></i> {{ seller.phone }}<br>
          <i class="fa fa-envelope"></i> {{ seller.email }}<br>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <a v-if="canEditSeller" :href="getCustomerEditUrl(buyer.id)" target="_blank">
            <span class="pull-right"><i class="fa fa-pencil"></i></span>
          </a>
          <h5>Acheteur</h5>
        </div>
        <div class="ibox-content">
          <i class="fa fa-user"></i> {{ buyer.firstname + ' ' + buyer.lastname }}<br>
          <i class="fa fa-phone"></i> {{ buyer.phone }}<br>
          <i class="fa fa-envelope"></i> {{ buyer.email }}<br>
          <i class="fa fa-building"> <a :href="walletUrlBuyer" target="_blank">{{ lemonwayIdBuyer }}</a></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatDate } from '../../helpers/filters/filter'

  export default {
    props: {
      price: {
        type: Number,
        required: true
      },
      command: {
        type: Object,
        required: true
      },
      vehicle: {
        type: Object,
        required: true
      },
      seller: {
        type: Object,
        required: true
      },
      buyer: {
        type: Object,
        required: true
      },
      canEditVehicle: {
        type: Boolean,
        default: true
      },
      canEditBuyer: {
        type: Boolean,
        default: true
      },
      canEditSeller: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      appraisalLabel () {
        return `Cabinet d'expertise ${this.vehicle.appraisalExpert.name} le ${formatDate(this.vehicle.appraisalDate)}`
      },
      appraisalEditUrl () {
        return process.env.VUE_APP_BACKOFFICE_DOMAIN + process.env.VUE_APP_RDV_EDIT + this.command.appraisal.id
      },
      vehicleUrl () {
        let domain = null

        switch (this.command.realm) {
          case 'heycar':
            domain = "" // TODO: add heycar domain here, refactoring in API GraphQL
            break;
          default:
            domain = process.env.VUE_APP_FRONTOFFICE_DOMAIN
        }

        return domain + this.vehicle.url
      },
      lemonwayIdBuyer () {
        return this.buyer.wallet.lemonwayId
      },
      walletUrlBuyer () {
        return this.buyer.wallet.url
      },
    },

     methods: {
       getCustomerEditUrl (id) {
         return process.env.VUE_APP_BACKOFFICE_DOMAIN + process.env.VUE_APP_CUSTOMER_EDIT + id
       }
     }
  }
</script>
